import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Table,
} from "react-bootstrap";
import { PlusCircle, Trash } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import axiosInstance from "./api/axiosInstance";
import axios from "axios";
import { FloatingLabel } from "react-bootstrap";

export default function BanquetBookingBootstrap() {
  const navigate = useNavigate();

  /* ---------------- STATES ---------------- */
  const [partyTypes, setPartyTypes] = useState([]);
  const [foodTypes, setFoodTypes] = useState([]);

  const [formData, setFormData] = useState({
    guestName: "",
    mobileNo: "",
    address: "",
    bookingDate: "",
    partyDate: "",
    partyTypeId: "",
  });

  const [items, setItems] = useState([{ foodTypeId: "", price: 0, qty: 1 }]);

  /* ---------------- API CALLS ---------------- */
  useEffect(() => {
    getPartyTypes();
    getFoodTypes();
  }, []);

  const getPartyTypes = async () => {
    try {
      const res = await axiosInstance.get("/api/Party_Type");
      setPartyTypes(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getFoodTypes = async () => {
    try {
      const res = await axiosInstance.get("/api/Food_Type");
      setFoodTypes(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  /* ---------------- HANDLERS ---------------- */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const addItem = () => {
    setItems([...items, { foodTypeId: "", price: 0, qty: 1 }]);
  };

  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const grandTotal = items.reduce((sum, i) => sum + i.price * i.qty, 0);

  /* ---------------- SAVE ---------------- */
  const handleSave = async () => {
    try {
      // 🔹 login user data from localStorage
      const loginUser = JSON.parse(localStorage.getItem("loginUser"));

      if (!loginUser || !loginUser.hotelid) {
        alert("Hotel ID not found. Please login again.");
        return;
      }

      const hotelId = loginUser.hotelid;

      // 🔹 main estimate UUID
      const estimateId = crypto.randomUUID();

      // 🔹 estimate details
      const estimateDetails = items.map((item) => ({
        id: crypto.randomUUID(),
        estimate_id: estimateId,
        food_type_id: item.foodTypeId,
        item_id: "89360a52-bf3d-4bed-867d-8a2778a9fb61", // backend handle karega
        rate: item.price,
        qty: item.qty,
        amount: item.price * item.qty,
      }));

      // 🔹 final payload (API format ke according)
      const payload = {
        id: estimateId,
        name: formData.guestName,
        mobileno: formData.mobileNo,
        address: formData.address,
        min_qty: 0,
        party_type_id: formData.partyTypeId,
        party_date: new Date(formData.partyDate).toISOString(),
        total_amount: grandTotal,
        gst_amount: 0,
        hotelid: hotelId, // ✅ LOCALSTORAGE SE
        createdon: new Date().toISOString(),
        estimate_detail: estimateDetails,
      };

      await axios.post("/api/Save_Estimate", payload);

      alert("Booking saved successfully ✅");
      navigate("/banquet-history");
    } catch (error) {
      console.error(error);
      alert("Something went wrong ❌");
    }
  };

  /* ---------------- UI ---------------- */
  return (
    <Container className="my-4">
      <Card className="shadow">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="fw-bold mb-0">Banquet Booking / Inquiry</h4>

            <Button
              variant="outline-secondary"
              onClick={() => navigate("/banquet-history")}
            >
              View Booking History
            </Button>
          </div>

          {/* Guest Details */}
          <Row className="mb-3 g-3">
            <Col xs={12} md={6}>
              <Form.Control
                className="w-100"
                placeholder="Guest Name"
                name="guestName"
                onChange={handleChange}
              />
            </Col>
            <Col xs={12} md={6}>
              <Form.Control
                className="w-100"
                placeholder="Mobile No"
                name="mobileNo"
                onChange={handleChange}
              />
            </Col>
          </Row>

          <Row className="mb-3 g-3">
            <Col xs={12}>
              <Form.Control
                className="w-100"
                placeholder="Address"
                name="address"
                onChange={handleChange}
              />
            </Col>
          </Row>

          {/* Dates + Party Type */}
          <Row className="mb-4 g-3">
            {/* BOOKING DATE */}
            <Col xs={12} md={3}>
              {/* Mobile View */}
              <div className="d-md-none">
                <FloatingLabel label="Booking Date">
                  <Form.Control
                    type="date"
                    name="bookingDate"
                    value={formData.bookingDate}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </div>

              {/* Desktop View */}
              <div className="d-none d-md-block">
                <Form.Label>Booking Date</Form.Label>
                <Form.Control
                  type="date"
                  name="bookingDate"
                  value={formData.bookingDate}
                  onChange={handleChange}
                />
              </div>
            </Col>

            {/* PARTY DATE */}
            <Col xs={12} md={3}>
              {/* Mobile View */}
              <div className="d-md-none">
                <FloatingLabel label="Party Date">
                  <Form.Control
                    type="date"
                    name="partyDate"
                    value={formData.partyDate}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </div>

              {/* Desktop View */}
              <div className="d-none d-md-block">
                <Form.Label>Party Date</Form.Label>
                <Form.Control
                  type="date"
                  name="partyDate"
                  value={formData.partyDate}
                  onChange={handleChange}
                />
              </div>
            </Col>

            <Col xs={12} md={3}>
             <Form.Label>Party Type</Form.Label>
              <Form.Select
                className="w-100"
                name="partyTypeId"
                onChange={handleChange}
              >
                <option value="">Select Party Type</option>
                {partyTypes.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col xs={12} md={3}>
             <Form.Label>Minimum Qty</Form.Label>
              <Form.Control
                type="number"
                className="w-100"
                name="minQty"
                onChange={handleChange}
                placeholder="Minimum Qty"
                min={1} // optional, minimum allowed value
              />
            </Col>
          </Row>

          {/* Items Table */}
          <div className="table-responsive">
            <Table bordered className="mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-nowrap">Item (Food Type)</th>
                  <th className="text-nowrap">Item Name</th>
                  <th className="text-nowrap">Price</th>
                  <th className="text-nowrap">Qty</th>
                  <th className="text-nowrap">Total</th>
                  <th className="text-nowrap">Action</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Select
                        className="w-100"
                        value={item.foodTypeId}
                        onChange={(e) =>
                          handleItemChange(index, "foodTypeId", e.target.value)
                        }
                      >
                        <option value="">Select Food</option>
                        {foodTypes.map((f) => (
                          <option key={f.id} value={f.id}>
                            {f.name}
                          </option>
                        ))}
                      </Form.Select>
                    </td>
                    <td>
                      <Form.Control
                        type="tex"
                        className="w-100"
                        onChange={(e) =>
                          handleItemChange(index, "itemname", +e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        className="w-100"
                        onChange={(e) =>
                          handleItemChange(index, "price", +e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        className="w-100"
                        value={item.qty}
                        onChange={(e) =>
                          handleItemChange(index, "qty", +e.target.value)
                        }
                      />
                    </td>
                    <td>₹ {item.price * item.qty}</td>
                    <td className="text-center">
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => removeItem(index)}
                      >
                        <Trash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Buttons */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-2 mt-4">
            <Button
              variant="outline-primary"
              size="sm"
              className="px-3 py-1 d-flex align-items-center justify-content-center"
              onClick={addItem}
            >
              <PlusCircle size={14} className="me-1" />
              Add Item
            </Button>

            <Button
              variant="success"
              size="sm"
              className="px-4 py-1 d-flex align-items-center justify-content-center"
              onClick={handleSave}
            >
              Save Booking
            </Button>
          </div>

          <h5 className="mt-3 text-end">Total Amount: ₹ {grandTotal}</h5>
        </Card.Body>
      </Card>
    </Container>
  );
}
